import { UIMSceneEnum } from '../../../../../../shared/enums/UIMSceneEnums.ts';
import { UIUtilsEjsVariables } from '../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { setElementOnClick } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIMNavigationController {
    slideToTab() {
        setElementOnClick(this.rankingTab, ()=>this.sceneController.loadScene(UIMSceneEnum.Leaderboard));
        setElementOnClick(this.lobbyTab, ()=>this.sceneController.loadScene(UIMSceneEnum.Lobby));
        setElementOnClick(this.playTab, ()=>this.sceneController.loadScene(UIMSceneEnum.Homepage));
        setElementOnClick(this.storeTab, ()=>this.sceneController.loadScene(UIMSceneEnum.Store));
        setElementOnClick(this.moreTab, ()=>this.sceneController.loadScene(UIMSceneEnum.More));
    }
    moveSliderTo(tab) {
        const leftPosition = UIMNavigationController.calculateSliderPosition(tab);
        this.animatedSlider.style.left = `${leftPosition}%`;
        this.animatedSlider.classList.remove('hidden');
        this.updateSelectedTab(tab);
    }
    deselectAllTabs() {
        this.rankingTab.classList.remove('selected');
        this.lobbyTab.classList.remove('selected');
        this.playTab.classList.remove('selected');
        this.storeTab.classList.remove('selected');
        this.moreTab.classList.remove('selected');
        this.navigationContainer.classList.remove('tab-0-selected', 'tab-1-selected', 'tab-2-selected', 'tab-3-selected', 'tab-4-selected');
        this.navigationContainer.classList.add('no-tab-selected');
        this.animatedSlider.classList.add('hidden');
    }
    static calculateSliderPosition(tab) {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile;
        const unselectedTabWidth = 1;
        const selectedTabWidth = 1.7;
        const tabCount = isStoreHidden ? 4 : 5;
        const totalTabsWidth = (tabCount - 1) * unselectedTabWidth + selectedTabWidth;
        const step = unselectedTabWidth / totalTabsWidth * 100;
        const updatedTab = isStoreHidden && tab == UIMSceneEnum.More ? tab - 1 : tab;
        return updatedTab * step;
    }
    updateSelectedTab(selectedScene) {
        this.navigationContainer.classList.remove('no-tab-selected');
        this.rankingTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Leaderboard);
        this.lobbyTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Lobby);
        this.playTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Homepage);
        this.storeTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Store);
        this.moreTab.classList.toggle('selected', selectedScene == UIMSceneEnum.More);
        this.updateTabSizing(selectedScene);
    }
    updateTabSizing(selectedScene) {
        this.navigationContainer.classList.remove('tab-0-selected', 'tab-1-selected', 'tab-2-selected', 'tab-3-selected', 'tab-4-selected');
        this.navigationContainer.classList.add(`tab-${selectedScene}-selected`);
    }
    hide() {
        this.navigationContainer.style.display = 'none';
    }
    show() {
        this.navigationContainer.style.display = 'grid';
    }
    handleStoreFeatureHide() {
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile != true) return;
        this.navigationContainer.classList.add('store-hidden');
        this.storeTab.classList.add('hidden');
    }
    constructor(sceneController){
        this.navigationContainer = document.getElementById('bottom-nav-container');
        this.animatedSlider = document.getElementById('bottom-nav-animated-slider');
        this.rankingTab = document.getElementById('bottom-nav-ranking-tab');
        this.lobbyTab = document.getElementById('bottom-nav-lobby-tab');
        this.playTab = document.getElementById('bottom-nav-play-tab');
        this.storeTab = document.getElementById('bottom-nav-store-tab');
        this.moreTab = document.getElementById('bottom-nav-more-tab');
        this.sceneController = sceneController;
        this.slideToTab();
        this.handleStoreFeatureHide();
        var _this_sceneController_scene;
        this.moveSliderTo((_this_sceneController_scene = this.sceneController.scene) !== null && _this_sceneController_scene !== void 0 ? _this_sceneController_scene : UIMSceneEnum.Homepage);
    }
}
